<div class="modal-header card-header">
    <div class="col-8">
        <span class="text-blue text-125">Jugadores de campeonatos anteriores</span><br>
        <span class="text-grey-m1">{{equipo.nombre}} - {{equipo.categoria?.nombre}}</span>
    </div>
    <div class="col-4 text-right">
        <button [disabled]="obtenerSeleccionados().length==0" (click)="agregarSeleccionados()" class="btn btn-primary" title="Agregar seleccionados al equipo">
            <i class="fa fa-user-plus text-110 mr-1"></i> {{obtenerSeleccionados().length}}
        </button>&nbsp;
        <button class="btn btn-danger" type="button" (click)="cerrarComponente()">
            <i class="fa fa-times red2 text-110 mr-1"></i>
        </button>
    </div>
</div>
<div class="modal-body card-body">
    <div class="row mb-2">
        <div class="col-12 col-md-7 mb-1">
            <input type="text" class="form-control" [(ngModel)]="texto_busqueda" placeholder="Buscar por nombre o C.I." />
        </div>
        <div class="col-12 col-md-5 mb-1 pt-2">
            <label>
                <input type="checkbox" class="align-middle" [(ngModel)]="solo_misma_categoria" />
                Solo esta categoría/disciplina
            </label>
        </div>
    </div>

    <div *ngIf="cargando" class="text-center text-grey p-3">Cargando historial...</div>
    <div *ngIf="!cargando && obtenerHistorialFiltrado().length==0" class="text-center text-grey p-3">
        No se encontraron jugadores de campeonatos anteriores.
    </div>

    <div *ngIf="!cargando && obtenerHistorialFiltrado().length>0" class="table-responsive lista-historial">
        <table class="table table-striped table-bordered table-hover mb-0">
            <thead>
                <tr class="bgc-orange-d2 text-white">
                    <th class="text-center">
                        <input #casilla_todos type="checkbox" class="align-middle" [checked]="todosSeleccionados()" (change)="seleccionarTodos(casilla_todos.checked)" />
                    </th>
                    <th>Foto</th>
                    <th>Jugador</th>
                    <th>Último campeonato</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of obtenerHistorialFiltrado() | orderBy:'jugador.persona.nombre_completo'" [ngClass]="{'text-grey-l1':item.ocupado_en}">
                    <td class="text-center">
                        <input type="checkbox" class="align-middle" [(ngModel)]="item.seleccionado" [disabled]="item.ocupado_en" />
                    </td>
                    <td>
                        <img class="foto-jugador" src="{{rest_server+item.jugador.persona.imagen}}" />
                    </td>
                    <td>
                        {{item.jugador.persona.nombre_completo}}<br>
                        <small>C.I. {{item.jugador.persona.ci}}
                            <span *ngIf="item.jugador.persona.fecha_nacimiento"> - {{item.jugador.persona.fecha_nacimiento | date:'dd/MM/yyyy'}}</span>
                        </small>
                        <div *ngIf="item.ocupado_en" class="text-danger text-90">Ya está en el equipo {{item.ocupado_en}}</div>
                    </td>
                    <td>
                        {{item.ultimo_campeonato}}<br>
                        <small>{{item.ultimo_equipo}} - {{item.ultima_categoria}} ({{item.ultima_disciplina}})</small>
                        <div *ngIf="item.cantidad_campeonatos>1"><small class="text-info">{{item.cantidad_campeonatos}} campeonatos</small></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
